import { GlobalData } from "../../Common/GlobalData";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";

export class BasesForming {
    public static readonly GRID = '#grid';
    public static readonly MARKET_PCT = '#marketPct';
    public static readonly FUNDAMENTAL_PCT = '#fundamentalPct';
    public static readonly TECHNICAL_PCT = '#technicalPct';
    public static readonly UPDATE_BTN = '#updateBtn';

    constructor() {
        this.init();
    }

    private init() {
        const self = this;

        $(BasesForming.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(this.getDataSourceOptions()),
            height: 915,
            groupable: false,
            editable: false,
            navigatable: false,
            sortable: true,
            filterable: true,
            pageable: false,
            resizable: true,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getSymbolLinkTemplate('StockChecklistReport?symbol=')),
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '16%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: 'eventDate',
                    title: 'Event<br>Date',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('eventDate')),
                },
                {
                    field: 'weeklyPctChangeVsPivot',
                    title: 'Weekly<br>% Change<br>vs Pivot',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'weeklyBaseType',
                    title: 'Weekly<br>Base<br>Type',
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'weeklyBaseStage',
                    title: 'Weekly<br>Base<br>Stage',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'currentPrice',
                    title: 'Current<br>Price',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'marketCap',
                    title: 'Market<br>Cap',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'compositeRating',
                    title: 'Comp<br>Rating',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'earningsPerShareRating',
                    title: 'EPS<br>Rating',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'relativeStrengthRating',
                    title: 'RS<br>Rating',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'accumDistRating',
                    title: 'A/D<br>Rating',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'smrRating',
                    title: 'SMR<br>Rating',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'industryGroupRank',
                    title: 'Ind<br>Group<br>Rank',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'industryName',
                    title: 'Industry<br>Name',
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: 'initialPublicOfferingDate',
                    title: 'IPO<br>Date',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('initialPublicOfferingDate')),
                },
                {
                    field: 'rank',
                    title: 'Total<br>Rank',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
            ]
        }).data('kendoGrid');

        $(BasesForming.UPDATE_BTN).on('click', () => {
            const grid = $(BasesForming.GRID).data("kendoGrid");
            if (grid) {
                grid.setDataSource(new kendo.data.DataSource(self.getDataSourceOptions()));
            }
        });
    }

    private getDataSourceOptions() {
        return {
            transport: {
                read: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_BASES_FORMING +
                    '?marketPct=' + ($(BasesForming.MARKET_PCT) as any)[0].value +
                    '&fundamentalPct=' + ($(BasesForming.FUNDAMENTAL_PCT) as any)[0].value +
                    '&technicalPct=' + ($(BasesForming.TECHNICAL_PCT) as any)[0].value,
            },
            error: () => {
                const notification = new Notification();
                notification.error('No data found to display');
            },
        };
    }
}
